import { createSlice } from "@reduxjs/toolkit";
import { UserSetting } from "generated/openApi";

export type UserSettingPageSizeOption = 20 | 50 | 100;
export type UserSettingMaxScreenWidthOption = "1024" | "1280" | "1360" | "1680" | "1920" | "Full";

export const userSettingPageSizeOptions: UserSettingPageSizeOption[] = [20, 50, 100];
export const userSettingMaxScreenWidthOptions: UserSettingMaxScreenWidthOption[] = [
  "1024",
  "1280",
  "1360",
  "1680",
  "1920",
  "Full",
];

interface UserSettingState {
  navPinned: boolean;
  pageSize: UserSettingPageSizeOption;
  multiSort: boolean;
  maxScreenWidth: UserSettingMaxScreenWidthOption;
}

const initialState: UserSettingState = {
  navPinned: false,
  pageSize: userSettingPageSizeOptions[0],
  multiSort: false,
  maxScreenWidth: userSettingMaxScreenWidthOptions[userSettingMaxScreenWidthOptions.length - 1],
};

export const userSettingSlice = createSlice({
  name: "userSetting",
  initialState,
  reducers: {
    setUserSettingInitialState: (state, action: { type: string; payload: UserSetting }) => {
      state.navPinned = action.payload.navPinned;
      state.multiSort = action.payload.multiSort;

      if (
        action.payload.pageSize &&
        userSettingPageSizeOptions.includes(Number(action.payload.pageSize) as UserSettingPageSizeOption)
      ) {
        state.pageSize = Number(action.payload.pageSize) as UserSettingPageSizeOption;
      }

      if (
        action.payload.maxScreenWidth &&
        userSettingMaxScreenWidthOptions.includes(action.payload.maxScreenWidth as UserSettingMaxScreenWidthOption)
      ) {
        state.maxScreenWidth = action.payload.maxScreenWidth as UserSettingMaxScreenWidthOption;
      }
    },
    setUserSettingNavPinned: (state, action: { type: string; payload: typeof initialState.navPinned }) => {
      state.navPinned = action.payload;
    },
    setUserSettingPageSize: (state, action: { type: string; payload: typeof initialState.pageSize }) => {
      state.pageSize = action.payload;
    },
    setUserSettingSortMethod: (state, action: { type: string; payload: typeof initialState.multiSort }) => {
      state.multiSort = action.payload;
    },
    setUserSettingMaxScreenWidth: (state, action: { type: string; payload: typeof initialState.maxScreenWidth }) => {
      state.maxScreenWidth = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setUserSettingInitialState,
  setUserSettingNavPinned,
  setUserSettingPageSize,
  setUserSettingSortMethod,
  setUserSettingMaxScreenWidth
} = userSettingSlice.actions;

export default userSettingSlice.reducer;
